import type { SyntheticEvent } from 'react';
import { Alert, Snackbar } from '@mui/material';
import { useError } from '@/providers/ErrorProvider/ErrorProvider';
import type { Severity } from '@/types/types';
import type { AppErrorSnackbarProps } from './IAppErrorSnackbar';
import { styles } from './styles';

const fallbackSeverity = (s: Severity): Exclude<Severity, ''> =>
    s === '' ? 'info' : s;

const AppErrorSnackbar = ({ anchorOrigin }: AppErrorSnackbarProps = {}) => {
    const err = useError();

    const reset = (_event?: SyntheticEvent | Event, reason?: string) => {
        if (reason === 'clickaway') return;
        err.DISPATCH({ type: 'RESET_ERROR' });
    };

    if (!err.state.showSnack) return null;

    return (
        <Snackbar
            open={err.state.showSnack}
            autoHideDuration={6000}
            onClose={reset}
            anchorOrigin={anchorOrigin}
        >
            <Alert
                onClose={reset}
                severity={fallbackSeverity(err.state.severity)}
                sx={styles.alert}
            >
                {err.state.alert}
            </Alert>
        </Snackbar>
    );
};

export default AppErrorSnackbar;
